export const calendarConstants = {
  WEEKDAYS_SHORT: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  WEEKDAYS_LONG: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  MONTHS: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ],
};

export const REGEX_CONSTANTS = {
  EMAIL_REGEX:
    /^(?!\s*$)(?!.*<[^>]*>)[a-zA-Z0-9._'-]+@(?!(?:.*\.\.)|(?:.*\.$))[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/,
  NAME_REGEX: /^[\p{L}\p{M}'\- ]+$/u,
  COMMON_REGEX: /^(?!.<[^>]>)[\p{L}\p{N}'\-\s]*$/u,
  COMMENTS_REGEX: /^(?!\s*$)(?!.*<[^>]*>)[\s\S]{1,2000}$/,
};

export const LEGAL_PAGE_SPECIFIC_DATA_LAYER_SESSION_STORAGE_KEYS = 'legalPageSpecificDataLayerKeys';
